(function () {
  'use strict';

  if (window.__elvtdPartnersCategoryInit) return;
  window.__elvtdPartnersCategoryInit = true;

  let overlay = null;
  let modalTitle = null;
  let modalSubtitle = null;
  let modalBrands = null;
  let isOpen = false;

  function buildModal() {
    overlay = document.createElement('div');
    overlay.className = 'elvtd-partners-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    overlay.innerHTML =
      '<div class="elvtd-partners-modal">' +
        '<button class="elvtd-partners-modal__close" aria-label="Fechar">&times;</button>' +
        '<h2 class="elvtd-partners-modal__title"></h2>' +
        '<p class="elvtd-partners-modal__subtitle"></p>' +
        '<div class="elvtd-partners-modal__brands"></div>' +
      '</div>';

    document.body.appendChild(overlay);

    modalTitle    = overlay.querySelector('.elvtd-partners-modal__title');
    modalSubtitle = overlay.querySelector('.elvtd-partners-modal__subtitle');
    modalBrands   = overlay.querySelector('.elvtd-partners-modal__brands');

    overlay.querySelector('.elvtd-partners-modal__close').addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal(title, subtitle, brands) {
    if (!overlay) buildModal();

    modalTitle.textContent = title;

    if (subtitle) {
      modalSubtitle.textContent = subtitle;
      modalSubtitle.style.display = '';
    } else {
      modalSubtitle.style.display = 'none';
    }

    modalBrands.innerHTML = brands
      .map(function (name) {
        return '<span class="elvtd-partners-category__pill">' + escapeHtml(name) + '</span>';
      })
      .join('');

    isOpen = true;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    overlay.scrollTop = 0;
    overlay.querySelector('.elvtd-partners-modal__close').focus();
  }

  var TRANSITION_MS = 300;

  function closeModal() {
    if (!overlay || !isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    setTimeout(function () {
      document.body.style.overflow = '';
    }, TRANSITION_MS);
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.elvtd-partners-category__show-all');
      if (!btn) return;

      var sectionId = btn.getAttribute('data-section-id');
      var title     = btn.getAttribute('data-modal-title') || '';
      var subtitle  = btn.getAttribute('data-modal-subtitle') || '';

      var dataEl = document.getElementById('elvtd-brands-' + sectionId);
      if (!dataEl) return;

      var brands = [];
      try {
        brands = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      openModal(title, subtitle, brands);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
